"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SuggestionCollection = /** @class */ (function () {
    function SuggestionCollection(suggestions) {
        this.suggestions = [];
        this.suggestions = suggestions;
    }
    Object.defineProperty(SuggestionCollection.prototype, "flatSuggestions", {
        get: function () {
            return this.suggestions.reduce(function (all, suggestion) { return (all.concat(suggestion.results)); }, []);
        },
        enumerable: true,
        configurable: true
    });
    return SuggestionCollection;
}());
exports.default = SuggestionCollection;
//# sourceMappingURL=suggestion_collection.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/suggestion_collection.js
// module id = +Jcx
// module chunks = 20 21